// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom3-Bom3Control-Bom3Control-module__box--zEzux {
  flex: 1;
  overflow: hidden;
  padding: 0 24px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom3/Bom3Control/Bom3Control.module.less"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,gBAAA;EAEA,eAAA;AAAF","sourcesContent":[".box {\n  flex: 1;\n  overflow: hidden;\n\n  padding: 0 24px; // На макете отступы общие\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsBom3-Bom3Control-Bom3Control-module__box--zEzux`
};
export default ___CSS_LOADER_EXPORT___;
